import type { ISODate } from "./types";

const MS_PER_DAY = 86_400_000;

export function toISODate(date: Date): ISODate {
  const local = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const y = local.getFullYear();
  const m = String(local.getMonth() + 1).padStart(2, "0");
  const d = String(local.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}` as ISODate;
}

export function parseISODate(date: ISODate): Date {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function addDays(date: ISODate, days: number): ISODate {
  const parsed = parseISODate(date);
  parsed.setDate(parsed.getDate() + days);
  return toISODate(parsed);
}

export function daysBetween(start: ISODate, end: ISODate): number {
  const a = Date.UTC(...dateParts(start));
  const b = Date.UTC(...dateParts(end));
  return Math.floor((b - a) / MS_PER_DAY);
}

export function formatHumanDate(date: ISODate): string {
  return new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long", year: "numeric" }).format(parseISODate(date));
}

export function weekday(date: ISODate): string {
  return new Intl.DateTimeFormat("ru-RU", { weekday: "long" }).format(parseISODate(date));
}

export function isSunday(date: ISODate): boolean {
  return parseISODate(date).getDay() === 0;
}

function dateParts(date: ISODate): [number, number, number] {
  const [year, month, day] = date.split("-").map(Number);
  return [year, month - 1, day];
}
